import React from 'react';
import PropTypes from 'prop-types';
import {Formik} from 'formik';
import Step3View from './Step3-view';
import {checkRequiredValues} from '../../utils/forms/checkRequiredValues';
import types from '../../types';
import {checkNextStepAndGo} from '../../utils/checkNextStepAndGo';
import {trackEvent} from "../../utils/trackEvent";
import {useIntl} from "react-intl";

const Step3 = ({
                 submitStep,
                 regType,
                 payload,
                 prevCompletedStepSign,
                 prevCompletedStepSignFalse
               }) => {
  const initialValues = {
    phoneNumber: '',
    city: '',
    street: '',
    houseNum: '',
    appartmentNum: '',
    ...payload
  };

  const validate = values => {
    const {
      city,
      street,
    } = values;
    let errors = {};
    errors = checkRequiredValues({
      city,
      street,
    }, errors);

    return errors;
  };
  const {formatMessage} = useIntl();
  const handleSubmit = values => {
    const {city, street, houseNum, appartmentNum} = values;
    submitStep({
      step: 3,
      data: {regType, prevCompletedStepSign, city, street, houseNum, appartmentNum},
    })
      .then(checkNextStepAndGo)
      .then(() => prevCompletedStepSignFalse())
      .then(() => {
          trackEvent('signup_step',
            {
              step_number: 3,
              step_name_en: 'Contact information',
              step_name_he: formatMessage({id: 'step3.page.title', defaultMessage: ''}),
              regType
            }
          )
        }
      )
      .catch(err => console.log({err}))
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validate={validate}
      enableReinitialize={true}
      validateOnChange={true}
      validateOnBlur={false}
    >
      {({isValid, submitCount}) => (
        <Step3View
          isValid={isValid || submitCount === 0}
        />
      )}
    </Formik>
  )
};

Step3.propTypes = {
  ...types.router,
  regType: PropTypes.string,
  payload: PropTypes.object,
  submitStep: PropTypes.func
};

export default Step3;
